import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import FormContainer from "../components/FormContainer";

import { useRegisterMutation } from "../slices/usersApiSlice";
import { setCredentials } from "../slices/authSlice";
import { toast } from "react-toastify";

const RegisterScreen = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [register, { isLoading }] = useRegisterMutation();

  const { userInfo } = useSelector((state) => state.auth);

  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const redirect = sp.get("redirect") || "/";

  useEffect(() => {
    if (userInfo) {
      navigate(redirect);
    }
  }, [navigate, redirect, userInfo]);

  const submitHandler = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
    } else {
      try {
        const res = await register({ name, email, phone, password }).unwrap();
        dispatch(setCredentials({ ...res }));
        navigate(redirect);
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    }
  };

  return (
    <FormContainer>
      <h1 className="text-end">הירשם</h1>
      <Form onSubmit={submitHandler}>
        <Form.Group className="my-2" controlId="name">
          <Col xs={12} className="text-end">
            <Form.Label>שם</Form.Label>
          </Col>
          <Col xs={12}>
            <Form.Control
              type="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              dir="rtl"
            ></Form.Control>
          </Col>
        </Form.Group>

        <Form.Group className="my-2" controlId="email">
          <Col xs={12} className="text-end">
            <Form.Label>כתובת מייל</Form.Label>
          </Col>
          <Col xs={12}>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              dir="rtl"
            ></Form.Control>
          </Col>
        </Form.Group>

        <Form.Group className="my-2" controlId="phone">
          <Col xs={12} className="text-end">
            <Form.Label>טלפון</Form.Label>
          </Col>
          <Col xs={12}>
            <Form.Control
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              dir="rtl"
            ></Form.Control>
          </Col>
        </Form.Group>

        <Form.Group className="my-2" controlId="password">
          <Col xs={12} className="text-end">
            <Form.Label>סיסמא</Form.Label>
          </Col>
          <Col xs={12}>
            <Form.Control
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              dir="rtl"
            ></Form.Control>
          </Col>
        </Form.Group>
        <Form.Group className="my-2" controlId="confirmPassword">
          <Col xs={12} className="text-end">
            <Form.Label>אימות סיסמא</Form.Label>
          </Col>
          <Col xs={12}>
            <Form.Control
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              dir="rtl"
            ></Form.Control>
          </Col>
        </Form.Group>

        <Row className="my-2">
          <Col className="d-flex justify-content-end">
            <Button disabled={isLoading} type="submit" variant="primary">
              הירשם
            </Button>
          </Col>
        </Row>

        {isLoading && <Loader />}
      </Form>

      <Row className="py-3">
        <Col className="text-end">
          לקוח קיים?{" "}
          <Link to={redirect ? `/login?redirect=${redirect}` : "/login"}>
            כניסה
          </Link>
        </Col>
      </Row>
    </FormContainer>
  );
};

export default RegisterScreen;
